function test_addToCart() {
	return
}

function ecom_cartMinus() {
	return
}

function ecom_cartPlus() {
	return
}

const allAddToCart = document.querySelectorAll(".cart-btn-ecom");
for (let elem of allAddToCart) {
	elem.style.display = "";
	elem.closest(".ecom-addtocart").querySelector(".cartplus-btn-ecom").style.display = "none";
	elem.closest(".ecom-addtocart").querySelector("input.qty_cart").value = 0;
}

document.querySelector(".cart-count.total-count").innerText = 0;

class lotNormalUserFunctions {
	cartItems;
	variantList;
	currentItem;
	cartUpdateTimeouts = {};
	delayUpdateTime = 2000;
	imInPage = document.getElementById("im-in").getAttribute("data-template");

	constructor() {
		this.cartItems = {};
		this.currentItem = {};
		this.variantList = [];
		//call to async constructor for start the flow
		this.asyncConstructor();
	}

	async asyncConstructor() {
      // console.log("normal user async constructor")
		//call to initiate Cart items for create and load the data to cartItems variabel
		await this.initiateCartItem();
		this.createListeners();
	}

	//function that create cart object
	async initiateCartItem() {
      // console.log("normal user initateCart item");
		const cartFetch = await fetch("/?sections=ecom-minicart");
		const cartFetchResponse = await cartFetch.json();

		const cartDiv = document.createElement("div");
		cartDiv.innerHTML = cartFetchResponse['ecom-minicart'];

		//get all script tags
		const allScripts = [...cartDiv.querySelectorAll("script")];
		if (allScripts.length == 0) {
            this.pageSetup()
			return // console.log("No items in the cart. returning without creating cartItems variable");
		}

		//create cart items object with product id and all the variants
		for (let script of allScripts) {
			let singleProductJson = JSON.parse(script.innerHTML);
			singleProductJson['variants'].pop();

			const productId = "prod_" + singleProductJson['variants'][0].product_id;
			const allItems = Object.keys(this.cartItems);

			this.variantList = this.variantList.concat(singleProductJson['variants']);

			if (allItems.includes(productId)) {
				continue;
			}

			this.cartItems[productId] = singleProductJson['variants'];
		}


		//GOING THROUG THE all the variants and find the matching variant,
		//then update the variant in the cartItem

		for (let i = 0; i < this.variantList.length; i++) {
			const selected_variant = this.variantList[i];
			const selectedProductId = selected_variant.product_id;
			const selectedVariantId = selected_variant.id;

			if (selected_variant.itemQty != false) {

				for (let j = 0; j < this.cartItems['prod_' + selectedProductId].length; j++) {

					if (selectedVariantId == this.cartItems['prod_' + selectedProductId][j].id) {
						this.cartItems['prod_' + selectedProductId][j].itemQty = selected_variant.itemQty;
					}
				}
			}
		}

		for (let item of Object.keys(this.cartItems)) {
			for (let i = 0; i < this.cartItems[item].length; i++) {

				if (this.cartItems[item][i].itemQty == false) {
					this.cartItems[item][i].itemQty = 0;
				}
			}
		}
		// console.log("needs to run page buttons works such as hide add to cart show item count etc.");
		//call to pagesetup for create page structure
		this.pageSetup();
	}

	createListeners() {

		document.addEventListener("click", function(e) {
			const target = e.target;
            
			const addToCartElem = target.closest("div.cart-btn-ecom");
			const plusElem = target.closest("button.pluse_btn");
			const minusElem = target.closest("button.minus_btn");

			if (addToCartElem) {
				this.addToCart(addToCartElem)
			}

			if (plusElem) {
				this.plusBtn(plusElem)
			}

			if (minusElem) {
				this.minusBtn(minusElem);
			}

		}.bind(this), false);

	}

	changeAllElemValuesBySelector(selector, value) {
		const elementList = [...document.querySelectorAll(selector)];
		if (elementList.length <= 0) {
			return // console.log("There are no elements with that selector. Returning do nothing. The selectors are ", selector);
		}

		for (let elem of elementList) {
			elem.value = value;
		}
	}

	changeAllElemTextBySelector(selector, value) {
		const elementList = [...document.querySelectorAll(selector)];
		if (elementList.length <= 0) {
			return // console.log("There are no elements with that selector. Returning do nothing. The selectors are ", selector);
		}

		for (let elem of elementList) {
			elem.innerText = value;
		}
	}

	changeAllElemHTMLBySelector(selector, value) {
		const elementList = [...document.querySelectorAll(selector)];
		if (elementList.length <= 0) {
			return // console.log("There are no elements with that selector. Returning do nothing. The selectors are ", selector);
		}

		for (let elem of elementList) {
			elem.innerHTML = value;
		}
	}

	changeAllElemShowHideBySelector(selector, value) {
		const elementList = [...document.querySelectorAll(selector)];
		if (elementList.length <= 0) {
			return // console.log("There are no elements with that selector. Returning do nothing. The selectors are ", selector);
		}

		for (let elem of elementList) {
			if (value == "hide") {
				elem.hidden = true;
				elem.style.display = "none";
			}
			if (value == "show") {
				elem.hidden = false;
				elem.style.display = "";

			}
		}
	}

	disableAllBtnBySelector(selector, value) {
		const elementList = [...document.querySelectorAll(selector)];
		if (elementList.length <= 0) {
			return // console.log("There are no elements with that selector. Returning do nothing. The selectors are ", selector);
		}

		for (let elem of elementList) {
			elem.disabled = true;
		}
	}

	enableAllBtnBySelector(selector, value) {
		const elementList = [...document.querySelectorAll(selector)];
		if (elementList.length <= 0) {
			return // console.log("There are no elements with that selector. Returning do nothing. The selectors are ", selector);
		}

		for (let elem of elementList) {
			elem.disabled = false;
		}
	}

    showNackbar(text, duration = 2900) {
      var snackbar = document.getElementById("snackbar");
      snackbar.innerHTML = text;
      snackbar.classList.add("show");

      setTimeout(()=>{
        snackbar.classList.remove("show");
      }, duration);
    }

	updateItemCount(productId) {
		if (productId == "" || !productId) {
			return;
		}

		const product = this.cartItems["prod_" + productId];
		let itemCount = 0;

		for (let item of product) {
			itemCount += item.itemQty;
		}

		if (itemCount == 0) {
			itemCount = 1
		}
		// console.log("total item qty is", itemCount);
		this.changeAllElemValuesBySelector(`input.ecom_cart_count_${productId}`, itemCount);
	}

	addToCart(target) {
        // console.log(target)
		const productId = target.dataset.productid;

		//check the product is is already in the cart items variable
		//if includes then only do display non the add to cart and return
		if (Object.keys(this.cartItems).includes("prod_" + productId)) {
			const allAddToCart = document.querySelectorAll(`.Bcart_${productId}`);
			for (let elem of allAddToCart) {
				elem.style.display = "none";
			}

			//show all the plus minus buttons
			const allPlusMinus = document.querySelectorAll(`.Pcart_${productId}`);
			for (let elem of allPlusMinus) {
				elem.style.display = "";
			}

			// console.log("already in the cart items ");
			return;
		}

		//create product object and add it to cart items variable
		const productJson = JSON.parse(document.querySelector(`#variant_data_${productId}`).innerText);
		this.cartItems['prod_' + productId] = [];

		const productVariants = productJson['variants'];
		productVariants.pop(); // remove last items from the array

		for (let selectedVariant of productVariants) {
			const variant = {};
			// console.log(selectedVariant)
			variant.available = selectedVariant.available;
			variant.compare_at_price = selectedVariant.compare_at_price;
			variant.featured_image = selectedVariant.featured_image;
			variant.id = selectedVariant.id;
			variant.itemCount = selectedVariant.itemCount; //inventory item count
			variant.itemQty = 0;
			variant.price = selectedVariant.price;
			variant.product_id = selectedVariant.product_id;
			variant.product_link = selectedVariant.product_link;
			variant.product_title = selectedVariant.product_title;

			this.cartItems['prod_' + productId].push(variant);
		}

		//hide all add to cart of that product
		this.changeAllElemShowHideBySelector(".Bcart_" + productId, "hide");

		//show all plus minus of that product
		this.changeAllElemShowHideBySelector(".Pcart_" + productId, "show");

		//add to variant method call
		//search first available variant and send to add to cart variant
		let variantId = productVariants[0];
		for (let variant of productVariants) {
			if (variant.available) {
				variantId = variant.id;
				break;
			}
		}

		//show and hide item added snackbar
        const productTitle = productVariants[0].product_title.split(" ").slice(0,2).join(" ") + "... item added.";
        this.showNackbar(productTitle);
      
		console.log(this.cartItems);
		this.addVariantToCart(productId, variantId);
	}

	async addVariantToCart(productId, variantId) {

		// console.log("productId", productId, "variantId", variantId);
		//disable all plus minus buttons for secure the add to cart event
		this.disableAllBtnBySelector(`.pluse_btn[data-productid="${productId}"], .minus_btn[data-productid="${productId}"]`, '');

		//change cart item count of the cartItems object and send the add to cart request to server immidiatly
		//search product in variant
		for (let i = 0; i < this.cartItems['prod_' + productId].length; i++) {

			let variant = this.cartItems['prod_' + productId][i];
			if (variant.id == variantId) {
				this.cartItems['prod_' + productId][i].itemQty += 1;
				break;
			}
		}

		//adding first variant to cart
		let request = {
			"items": []
		}
		request["items"] = [{
			"id": variantId,
			"quantity": 1
		}];

        //add to cart variant
		try {
          const addVariantFetch = await fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify(request)
          })
  
          const _json = await addVariantFetch.json();
          // console.log(_json);
        } catch(e) {
          window.location.reload();
          return;
        }

		this.updateItemCount(productId);

        //reload page if it is in cart page
        if (this.imInPage == "cart") {
          window.location.reload();
          return;
        }
		//update the page
		this.pageSetup();

		this.enableAllBtnBySelector(`.pluse_btn[data-productid="${productId}"], .minus_btn[data-productid="${productId}"]`, '');
	}

	async plusBtn(target, currentPrice) {
		const productId = target.dataset.productid;
		// console.log("plus button product id", productId);

        const maxItemCount = parseInt(target.getAttribute("data-max-count")) || Infinity;
        const currentItemCount = parseInt(document.querySelector(`input[data-productid="${productId}"], .ecom_cart_count_${productId}`).value);

        // console.log({ maxItemCount, currentItemCount })
      
        if(currentItemCount >= maxItemCount) {
          return Swal.fire({
				title: 'Maximum items added',
				showDenyButton: false,
				denyButtonText: `OK`,
				allowOutsideClick: false
			});
        }

		//disable all plus minus buttons for secure the add to cart event
		this.disableAllBtnBySelector(`.pluse_btn[data-productid="${productId}"], .minus_btn[data-productid="${productId}"]`, '');
		// console.log("productId", productId);

		//search available variant and add to cart
		currentPrice = false;
		// console.log(this.cartItems['prod_' + productId]);

		let i = 0;
		let isAllAdded = true;
		while (i < this.cartItems['prod_' + productId].length) {
			const selectedVariant = this.cartItems['prod_' + productId][i];

			if (selectedVariant.available == false) {
				i += 1
				continue;
			}
			if (currentPrice == false) {
				currentPrice = selectedVariant.price;
			}

			if (selectedVariant.available && (selectedVariant.itemQty < selectedVariant.itemCount)) {
				isAllAdded = false;
				if (selectedVariant.itemQty > 0) {
					currentPrice = selectedVariant.price;
				}
				// console.log("selectedVariant price", selectedVariant.price, "currentPrice", currentPrice);
				//if price changes as greator
				if (selectedVariant.price != currentPrice) {

					const alertResult = await Swal.fire({
						title: 'You just added the last item from this price! You can continue shopping from next price lot',
						showDenyButton: true,
						showCancelButton: false,
						confirmButtonText: 'Do it',
						denyButtonText: `Don't`,
						allowOutsideClick: false
					});

					//if deny the alert then return doing nothing;
					if (alertResult.isDenied) {
						//re enable plus minus buttons
						this.enableAllBtnBySelector(`.pluse_btn[data-productid="${productId}"], .minus_btn[data-productid="${productId}"]`, '');

						return;
					}

					return this.addVariantToCart(productId, selectedVariant.id);

				} else if (selectedVariant.price == currentPrice) {
					// console.log("inside price is same")
					this.cartItems['prod_' + productId][i].itemQty += 1;
					break;
				}
			}

			i += 1;
		}

		//check all products are added to cart if yes show out of stock
		if (isAllAdded) {
			const alertResult = await Swal.fire({
				title: 'Out of stock',
				showDenyButton: false,
				denyButtonText: `OK`,
				allowOutsideClick: false
			});
			//re enable plus minus buttons
			this.enableAllBtnBySelector(`.pluse_btn[data-productid="${productId}"], .minus_btn[data-productid="${productId}"]`, '');
			return;
		}

		//update item count 
		this.updateItemCount(productId);

		//update the page
		this.pageSetup();

		//re enable plus minus buttons
		this.enableAllBtnBySelector(`.pluse_btn[data-productid="${productId}"], .minus_btn[data-productid="${productId}"]`, '');

		//when successfully added item to cart , call to update cart function
		this.createUpdateTimeouts(productId);

		// console.log("my cart=>", this.cartItems);
	}

	async minusBtn(target) {
		const productId = target.dataset.productid;
		// console.log(target);

		//disable all plus minus buttons for secure the add to cart event
		this.disableAllBtnBySelector(`.pluse_btn[data-productid="${productId}"], .minus_btn[data-productid="${productId}"]`, '');

		const variantCount = this.cartItems["prod_" + productId].length -1 ;

		//remove items from cart
		for (let i = variantCount; i >= 0; i--) {
			const selectedVariant = this.cartItems["prod_" + productId][i];
            
			if (selectedVariant.available == false) {
				continue;
			}

			if (selectedVariant.itemQty <= 0) {
				this.cartItems["prod_" + productId][i].itemQty = 0; //do this for secure the itemqty not going to below 0;
				continue;
			}

			this.cartItems["prod_" + productId][i].itemQty -= 1;
			break;
		}

		let itemCount = 0;
		//get item count
		for (let i = variantCount; i >= 0; i--) {
			const selectedVariant = this.cartItems["prod_" + productId][i];
			if (selectedVariant.available == false) {
				continue;
			}

			itemCount += this.cartItems["prod_" + productId][i].itemQty;
		}

		//update item count 
		this.updateItemCount(productId);

		//when successfully removed  item in the cart if item count is not 0, call to update cart function
		if (itemCount > 0) {
			this.createUpdateTimeouts(productId);
		}

		//if item count is 0 then call to item delete option 
		if (itemCount == 0) {
			//remove delay update cart timeouts
			clearInterval(this.cartUpdateTimeouts?.["prod_" + productId]);

			//hide all add to cart of that product
			this.changeAllElemShowHideBySelector(".Bcart_" + productId, "show");

			//show all plus minus of that product
			this.changeAllElemShowHideBySelector(".Pcart_" + productId, "hide");

			await this.removeEntireProduct(productId);
		}

		this.pageSetup();
		//re enable plus minus buttons
		this.enableAllBtnBySelector(`.pluse_btn[data-productid="${productId}"], .minus_btn[data-productid="${productId}"]`, '');

		// console.log("inside minus button", this.cartItems);
	}

  	async removeEntireProduct(productId) {
        //tempory hide cart item
        document.querySelector(`.minicart_product_${productId}`).hidden = true;
        this.changeAllElemShowHideBySelector(".Bcart_" + productId, "show");
        this.changeAllElemShowHideBySelector(".Pcart_" + productId, "hide");
        
		//create update 
		let updateObj = {
			updates: {}
		}

		for (let i = 0; i < this.cartItems['prod_' + productId].length; i++) {
			const selectedVariant = this.cartItems['prod_' + productId][i];
			updateObj.updates[selectedVariant.id] = 0;
		}
		const _fetch = await fetch(window.Shopify.routes.root + "cart/update.js", {
			method: "POST",
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(updateObj)
		});
		const _replyJson = await _fetch.json();
		// console.log("remove update response => ", _replyJson);
		delete(this.cartItems['prod_' + productId]);

        this.pageSetup();
        if(this.imInPage == "cart") {
          window.location.reload();
        }
	}


	async createUpdateTimeouts(productId, type) {
		//clear already timeouts
		clearInterval(this.cartUpdateTimeouts?.["prod_" + productId]);

		//create update 
		let updateObj = {
			updates: {}
		}

		for (let i = 0; i < this.cartItems['prod_' + productId].length; i++) {
			const selectedVariant = this.cartItems['prod_' + productId][i];
			updateObj.updates[selectedVariant.id] = selectedVariant.itemQty;
		}

		//create delayed add to cart timeout
		this.cartUpdateTimeouts["prod_" + productId] = setTimeout(async function() {
			const _fetch = await fetch(window.Shopify.routes.root + "cart/update.js", {
				method: "POST",
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(updateObj)
			});
			const _replyJson = await _fetch.json();
			// console.log("delay update response => ", _replyJson);

		}, this.delayUpdateTime);
	}


	pageSetup() {

		this.updateMinicartItemCount();

		//show hide add to cart buttons and product item count
		this.productBtnsCount()

		//create minicart
		this.createMinicart();

		//cart page 
		if (this.imInPage == "cart") {
			this.cartPageCreate();
		}
        window.dispatchEvent(new CustomEvent("change-currency"));
	}

	updateMinicartItemCount() {
		//update the page elements [show hide buttons, create variant table]
		if (Object.keys(this.cartItems).length == 0) {
			//update cart count
			this.changeAllElemTextBySelector(".cart-count.total-count", 0); //for currency change
			return;
		}

		let itemCount = 0;
		const itemList = Object.keys(this.cartItems);
		for (let item of itemList) {
			const selectedItem = this.cartItems[item];
			for (let variant of selectedItem) {
				if (variant.available) {
					itemCount += variant.itemQty;
				}
			}
		}

		this.changeAllElemTextBySelector(".cart-count.total-count", itemCount);
	}

	productBtnsCount() {
		const itemList = Object.keys(this.cartItems);
		for (let item of itemList) {
			const selectedItem = this.cartItems[item];
			let itemCount = 0;
			let productId = 0;
			for (let variant of selectedItem) {
				if (variant.available) {
					variant.itemQty += itemCount;
				}
				productId = variant.product_id;
			}

			//hide all add to cart of that product
			this.changeAllElemShowHideBySelector(".Bcart_" + productId, "hide");

			//show all plus minus of that product
			this.changeAllElemShowHideBySelector(".Pcart_" + productId, "show");

			//update all item count of product ecom_cart_coun
			this.updateItemCount(productId);
		}
	}

	createMinicart() {
		let minicartHTML = `<p class="minicart_title">ORDER SUMMARY</p><div class="mini-cart-items-wrapper">`;
        let minicartBtn = document.querySelector('button.normal_checkout');
        let normalCartBox = document.querySelector(`#normal_cart_box`);
        
		const itemList = Object.keys(this.cartItems);
        let cartTotal = parseFloat(0);
      
		if (itemList.length == 0) {
          document.querySelector(`#normal_cart_box`).innerHTML = "";
          return
        };

		for (let item of itemList) {
        
			let itemCount = 0;
			let productId = this.cartItems[item][0].product_id;
            let productLink = this.cartItems[item][0].product_link
			let totalPrice = 0;

			minicartHTML += `<div class="minicart_row minicart_product_${productId}">`;
            minicartHTML += `<div class="remove-minicart-item" onclick="_lotNormalUserFunctions.removeEntireProduct('${productId}');">✕</div>`;
			minicartHTML += `<div class="minicart-img-container" >`;
            minicartHTML += `<a href="${productLink}"><img src="${this.cartItems[item][0].featured_image}"></a>`;
            minicartHTML += `</div>`;

            minicartHTML += `<div class="minicart-itm-data-wrapper">`;//starting mini cart data wrapper
			minicartHTML += `<div class="minicart_items_container minicart_items_container_${productId}">`;
            minicartHTML += `<p class="minicart_title minicart_title_p">${this.cartItems[item][0].product_title}</p>`;
          
			const selectedItem = this.cartItems[item];
            // console.log(selectedItem)
			for (let variant of selectedItem) {
				if (!variant.available) {
					continue;
				}
				if (variant.itemQty <= 0) {
					continue;
				}

				let variantPrice = variant.price;
				variantPrice = (variantPrice / 100).toFixed(2);
				let variantItemCount = variant.itemQty;
				itemCount += variantItemCount;
				totalPrice += variant.price * variantItemCount ;
                let compareAtPrice = (parseFloat(variant.compare_at_price) / 100 ).toFixed(2)
				minicartHTML += `<div class="item_count"> ${ (compareAtPrice > 0) ? '<span class="line-through" data-price data-originallkr="'+compareAtPrice+'"> '+compareAtPrice+' </span>': '' }
                <span data-price data-originallkr="${variantPrice}"> ${variantPrice} </span> x ${variantItemCount}</div>`;
			}

            minicartHTML += `</div>`;//ending mini cart data wrapper

            totalPrice = (totalPrice /100).toFixed(2);
            //minicart plus minus
            minicartHTML += `<div class="minicart_button_container">`;
            minicartHTML += `<div class="minicart_minus"> <button class="minus_btn"  data-productid="${productId}"> - </button></div>`;
            minicartHTML += `<div class="minicart_item_count_container"> <input type="number" class="minicart_item_count ecom_cart_count_${productId}" value="${itemCount}"> </div>`;
            minicartHTML += `<div class="minicart_plus"> <button class="pluse_btn" data-productid="${productId}"> + </button></div></div>`;
            minicartHTML += `</div>`;

            //minicart single item total
            minicartHTML += '<div class="minicart-item-total">';
            minicartHTML += `<div class="minicart_product_total">Total <span  data-price data-originallkr="${totalPrice}">${totalPrice}</span></div>`;
            minicartHTML += `</div>`;
          
			minicartHTML += "</div>";
            
            cartTotal += parseFloat(totalPrice);
		}

        minicartHTML += `</div>`;// end mini cart items wrapper
        minicartHTML += `<div class="TotalBtnChkBtnWrapper">`;// total and checkout btns wrapper start
        minicartHTML += `<p class="alert-cart" ${ (cartTotal >= 0) ? 'hidden': '' }> </p>`;
        minicartHTML += `<div class="total_row"><span>Total</span> <span data-price data-originallkr="${cartTotal}">Rs ${cartTotal} LKR </span></div>`;
		minicartHTML += `<a > <button class="Ncheckout_btn normal_checkout">Checkout</button> </a>`;
        minicartHTML += `</div">`;// total and checkout btns wrapper end
		//append html to minicart
        
        normalCartBox.dataset.ecomTotal = cartTotal;
		normalCartBox.innerHTML = minicartHTML;
      
        if( cartTotal > 0) {
          document.querySelector('button.normal_checkout').disabled = false;
        } else {
          document.querySelector('button.normal_checkout').disabled = true;
        }
	}

	cartPageCreate() {
      // console.log(`cart page create `);
        const cartRow = document.querySelector(".ecom-cart-row");
		const itemList = Object.keys(this.cartItems);
		if (itemList.length == 0) {
          cartRow.hidden = false;
          return;
        };

		let cartHTML = "";
        let totalPriceVal = 0;
		for (let item of itemList) {
			let itemCount = 0;
			let productId = this.cartItems[item][0].product_id;
			let totalPrice = 0;

			const selectedItemForCount = this.cartItems[item];
			for (let variant of selectedItemForCount) {
				if (!variant.available) {
					continue;
				}
				if (variant.itemQty <= 0) {
					continue;
				}
				itemCount += variant.itemQty;
			}

			cartHTML += `<div class="ecom_cart_row ecom_cart_product_${productId}"> `;
            cartHTML += `<div class="ecom-cart-mobile-title"><p class="cart-mobile-title">${this.cartItems[item][0].product_title}</p></div>`;
			cartHTML += `<a onclick="_lotNormalUserFunctions.removeEntireProduct('${productId}')" class="cart-item--remove-link" data-productid="${productId}" 
          data-cartitem-remove="" data-no-instant="" >
          <svg aria-hidden="true" focusable="false" role="presentation" width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.08785659,5 L9.77469752,1.31315906 L8.68684094,0.225302476 L5,3.91214341 L1.31315906,0.225302476 L0.225302476,1.31315906 L3.91214341,5 L0.225302476,8.68684094 L1.31315906,9.77469752 L5,6.08785659 L8.68684094,9.77469752 L9.77469752,8.68684094 L6.08785659,5 Z"></path>
            </svg>
              </a>`
			cartHTML += `<div class="ecom_cart_details_container ecom_cart_details_container_${productId}">
          <img src="${this.cartItems[item][0].featured_image}">
          <p class="ecom_cart_title minicart_title_p ecom-desktop-title "> ${this.cartItems[item][0].product_title} </p></div>`;
          
            cartHTML += `<div class="cart-item-elem-wrapper">` //wrap element for plus minus buttons and lot breakdown
			cartHTML += `<div class="cart_page_container">`;
			cartHTML += `<div class="cart_page_minus"> <button class="minus_btn"  data-productid="${productId}"> - </button></div>`;
			cartHTML += `<div class="cart_page_item_count_container"> <input type="number" class="minicart_item_count ecom_cart_count_${productId}" value="${itemCount}"> </div>`;
			cartHTML += `<div class="cart_page_plus"> <button class="pluse_btn" data-productid="${productId}"> + </button></div>`;
			cartHTML += "</div>";

			cartHTML += `<div class="ecom_cart_items_container ecom_cart_items_container_${productId}">`;

			itemCount = 0;
			totalPrice = 0;
			const selectedItem = this.cartItems[item];
			for (let variant of selectedItem) {
                // console.log(variant)
				if (!variant.available) {
					continue;
				}
				if (variant.itemQty <= 0) {
					continue;
				}
				let variantPrice = variant.price;
				variantPrice = (variantPrice / 100).toFixed(2);
                let compareAtPrice = (variant.compare_at_price / 100).toFixed(2);
				let variantItemCount = variant.itemQty;
				itemCount += variantItemCount;
				totalPrice += variant.price *  variant.itemQty ;
				cartHTML += `<div class="item_count">
                  <span data-compare="${compareAtPrice}" data-price data-originallkr="${compareAtPrice}">LKR ${compareAtPrice} </span> 
                   <span data-price data-originallkr="${(variant.price /100).toFixed(2)}"> LKR ${ (variant.price /100).toFixed(2)} </span> x ${variant.itemQty}</div>`;
			}
			cartHTML += `</div>`;
            cartHTML += '</div>';//wrap element for plus minus buttons and lot breakdown end
			cartHTML += `<div class="total_item_count" data-price data-originallkr="${(totalPrice /100).toFixed(2)}">LKR ${(totalPrice /100).toFixed(2)}</div>`;
			cartHTML += "</div>"
            totalPriceVal += totalPrice
		}

     
        cartHTML += `
                <div class="cart-ordernote">
                  <div class="opt_main_wrapper">
                    <h5>PURCHASE FOR</h5>
                    <div class="opt_wrapper">
                      <div class="opt_mySelf_wrapper">
                        <div class="opt_mySelf">
                          <input type="radio" id="buyformyself" name="attributes[Purchase Options]" value="myself" class="required" checked="">
                          <img class="opt_img" src="https://cdn.shopify.com/s/files/1/0592/3861/3149/files/cart.png?v=1641882051">
                          <label for="buyformyself">Buy for Myself</label>
                        </div>
                      </div>
                      <div class="opt_gift_wrapper">
                        <div class="opt_gift">
                          <input type="hidden" name="attributes[Gift Wrapping]" value="No">
                          <input type="radio" id="giftwrapping" name="attributes[Purchase Options]" value="gift" class="required">
                          <img class="opt_img" src="https://cdn.shopify.com/s/files/1/0592/3861/3149/files/gift.png?v=1641882051">
                          <label for="giftwrapping">Send as a Gift <span style="font-size:12px;">(Applicable only for card payment orders)</span></label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <span class="cart-ordernote-heading">Enter any special delivery instructions below:</span>
                  <div class="form-field">
                    <textarea class="form-field-input form-field-textarea" maxlength="250" name="note" id="cart-note"></textarea>
                    <label class="form-field-title" for="cart-note">Special instructions</label>
                  </div>
                </div>
        `;
		const cartItemContainer = document.querySelector(`.ecom-cart-item`);
        cartItemContainer.innerHTML = cartHTML;
        cartRow.hidden = false;
      
        const cartTotalElem = document.querySelector(".cart-page-totle");
        cartTotalElem.setAttribute("data-originallkr", totalPriceVal);
        cartTotalElem.setAttribute("data-price", totalPriceVal);

        this.freeShippingEligibilityMsg((totalPriceVal /100).toFixed(2));
      
        this.cart_page_total_update( (totalPriceVal /100).toFixed(2) );
	}

  cart_page_total_update(total) {
    const total_cart_elements = document.querySelectorAll("[data-ecom-cart-total]");
    for(let elem of total_cart_elements) {
      elem.setAttribute("data-originallkr", total);
    }
    document.dispatchEvent(new CustomEvent("cart:totalupdate", { bubbles: true, detail: {cart_total: total} }));
    //cs app installed (AIOD ) 
    // window.fire_cart_data();
  }

  freeShippingEligibilityMsg(total) {
    total = parseFloat(total);
    let msg = ``;
    let total_margin = parseFloat(`3500` || 0);
    let percentage;
    
    if(total_margin > total) {
      percentage = ((total / total_margin) * 100).toFixed(2);
      if(percentage < 4) {
        percentage = 4;
      }
      msg = `{amount}/= away <br> from free shipping`.replaceAll("{amount}", (total_margin - total).toFixed(2) );
    }
    
    if(total_margin <= total) {
      percentage = 100;
      msg = `Enjoy free shipping!`;
    }

    const progress_bar_thumb = document.querySelector(".progressbar .progressbar-fill");
    progress_bar_thumb.style.width = `${percentage}%`;
    
    const shipping_msg = document.querySelector(".free-shipping-ecom .shipping-text");
    shipping_msg.innerHTML = msg;
  }
}

window._lotNormalUserFunctions = new lotNormalUserFunctions()